import { getDashboardJson } from "../services/dashboardServices";

const initialState = {
  stats1: [],
  trending_projects: { data: [] },
};

export const dashboard_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_DASHBOARD":
      return {
        ...state,
        stats1: getDashboardJson(action.payload),
      };
    case "GET_TRENDINF_PROJECTS":
      return {
        ...state,
        trending_projects: action.payload,
      };
    default:
      return state;
  }
};
